import HiringPreferencesBanner from './HiringPreferencesBanner.component';

export default HiringPreferencesBanner;